import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import BannerAlert from "../../../../../components/wpl/banner-alert/src";
import { cssReset } from "../../../../../libraries/wpl/foundations/src";
import GlobalFooter from "../../../../../patterns/global-footer/src/index";

import CTASectionPaidLpJswPm from "./sections/cta";
import HeroSectionPaidLpJswPm from "./sections/hero";
import SideBySideAlternatingImageAndTextSectionPaidLpJswPm from "./sections/sideBySideAlternatingImageAndTextSection";
import SocialProofPaidLpJswPm from "./sections/social-proof";
import JiraSoftwareNavPaidLpJswPm from "./sections/software-jira-navbar";
import TabsPaidLpJswPm from "./sections/tabs";

export const JiraSoftwarePageTemplatePaidLpJswPm = () => {
    const intl = useIntl();

    const bannerMessages = {
        identifier:
            "JiraSoftwarePage.PaidLpJswPm.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "JiraSoftwarePage.banner-alert.text",
            defaultMessage:
                "Get early access to Atlassian Intelligence, your new virtual teammate that deeply understands how teams collaborate to accelerate work."
        }),
        linkText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence")
    };

    return (
        <div css={cssReset}>
            <JiraSoftwareNavPaidLpJswPm />
            <BannerAlert
                identifier={bannerMessages.identifier}
                text={bannerMessages.text}
                linkUrl={bannerMessages.linkUrl}
                linkText={bannerMessages.linkText}
            />
            <HeroSectionPaidLpJswPm />
            <TabsPaidLpJswPm />
            <SideBySideAlternatingImageAndTextSectionPaidLpJswPm />
            <CTASectionPaidLpJswPm />
            <SocialProofPaidLpJswPm />
            <GlobalFooter />
        </div>
    );
};
